import * as React from "react";

export const renderWithLayout = (layoutComponent: (React.ComponentClass<any> | React.StatelessComponent<any>), componentProps: any = {}) =>
    <TOriginalProps extends {}>(
        Component: (React.ComponentClass<TOriginalProps>
            | React.StatelessComponent<TOriginalProps>)
    ) => {
        const RenderWithLayout: React.StatelessComponent<any> = props => {
            const Layout = layoutComponent;

            return (
                <Layout {...props} >
                    <Component {...componentProps} {...props} />
                </Layout>
            );
        };

        return RenderWithLayout;
    };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/RenderWithLayout/RenderWithLayout.tsx